import React from "react";

import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@tiny/components";
import TrashFull from "@tiny/icons/generated/TrashFull";
import { useStyles } from "./DeleteListDialog.styles";

export interface ItemComponentProps<T> {
  item: T;
}

export interface DeleteListDialogProps<T> {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  title: string;
  ItemComponent: (props: ItemComponentProps<T>) => JSX.Element;
  data: T[];
  idKey: keyof T;
  deleting: boolean;
}

function DeleteListDialog<T>(props: DeleteListDialogProps<T>) {
  const { open, onClose } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClose
    >
      <DeleteListDialogContent {...props} />
    </Dialog>
  );
}

function DeleteListDialogContent<T>(props: DeleteListDialogProps<T>) {
  const { onClose, onDelete, title, data, ItemComponent, idKey, deleting } =
    props;

  const classes = useStyles();

  return (
    <>
      <DialogTitle onClose={onClose}>{title}</DialogTitle>
      <DialogContent>
        <ul className={classes.list}>
          {data.map((item) => (
            <li key={item[idKey] as unknown as string} className={classes.item}>
              <ItemComponent item={item} />
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="red"
          endIcon={<TrashFull />}
          onClick={onDelete}
          loading={deleting}
          disabled={deleting}
        >
          Delete
        </Button>
      </DialogActions>
    </>
  );
}

export default DeleteListDialog;
